import React, { useState, useEffect, useContext } from "react";
import NotificationContext from "../context/NotificationContext";
import NotificationList from "../components/NotificationList/NotificationList";
import fakeId from "../utils/fakeId";
import WsContext from "../context/WsContext";
import RefreshButton from "../ui/RefreshButton/RefreshButton";

import {
  requests,
  SetNotificationReadService,
  NotificationListService
} from "../utils/api";

import { notificationType } from "../constants";

const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const [connectionLost, setConnectionLost] = useState(false);
  const wsContext = useContext(WsContext);

  const load = () => {
    NotificationListService().then(data => {
      setNotifications(prev => [...data.notifications, ...prev]);
    });
  };

  const loadNew = () => {
    NotificationListService().then(data => {
      setNotifications(prev => {
        const existing = prev.reduce((res, current) => {
          console.log(current.id);
          res[current.id] = true;
          return res;
        }, {});

        const new_notifications = data.notifications.reduce((res, current) => {
          if (!existing[current.id]) {
            res.push(current);
          }
          return res;
        }, []);

        return [...new_notifications, ...prev];
      });
    });
  };

  const handleHttp500 = e => {
    showSimpleNotification({
      title: "500",
      text: "Что-то пошло не так",
      color: "red"
    });
  };

  const handleDisconnect = () => {
    setConnectionLost(true);
  };

  useEffect(() => {
    load();
    wsContext.eventEmitter.subscribe("notifications_update", loadNew);
  }, []);

  useEffect(() => {
    wsContext.eventEmitter.subscribe("http500", handleHttp500);
    wsContext.eventEmitter.subscribe("disconnect", handleDisconnect);
  }, []);

  const showSimpleNotification = ({ title, text, color }) => {
    const notification = {
      title,
      text,
      color,
      type: notificationType.simple,
      id: fakeId()
    };

    setNotifications(prev => {
      return [notification, ...prev];
    });
  };

  const onClose = ({ id }) => {
    setNotifications(prev => {
      return prev.filter(n => n.id != id);
    });

    if (typeof id == "number") {
      SetNotificationReadService({ ids: [id] });
    }
  };

  const onAllClose = () => {
    setNotifications([]);
    const ids = notifications.reduce((result, current) => {
      if (typeof current.id == "number") {
        result.push(current.id);
      }

      return result;
    }, []);

    if (ids.length != 0) {
      SetNotificationReadService({ ids });
    }
  };

  const handlePageReload = () => {
    window.location.reload();
  };

  return (
    <NotificationContext.Provider value={{ showSimpleNotification }}>
      <React.Fragment>
        {children}
        <NotificationList
          notifications={notifications}
          onClose={onClose}
          onAllClose={onAllClose}
        />
        {connectionLost && (
          <RefreshButton onClick={handlePageReload}>
            Соединение потеряно. Пожалуйста, обновите, страницу.
          </RefreshButton>
        )}
      </React.Fragment>
    </NotificationContext.Provider>
  );
};

export default NotificationProvider;
